import { useToastStore } from '@/app/store/notificationStore';

// Renders the fire-and-forget toast queue from the UI store. Mounted
// once in AppProviders so any mutation anywhere can push a toast via
// `useToastStore.getState().pushToast(...)` without prop drilling.
export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const dismissToast = useToastStore((s) => s.dismissToast);

  return (
    <div className="toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div key={toast.id} role="status" className={`toast toast--${toast.variant}`}>
          <p className="toast__title">{toast.title}</p>
          {toast.description && <p className="toast__description">{toast.description}</p>}
          <button onClick={() => dismissToast(toast.id)} aria-label="Dismiss">
            <i className="ti ti-x" />
          </button>
        </div>
      ))}
    </div>
  );
}
